export const UPDATE_LOADING_FIRMAS = 'UPDATE_LOADING_FIRMAS';
export const UPDATE_ERROR_FIRMAS = 'UPDATE_ERROR_FIRMAS';
export const UPDATE_FIRMAS = 'UPDATE_FIRMAS';